import React from 'react';
import { loginStatusesDataSource } from 'infrastructure/data-sources/login-statuses';
import { debug } from 'utils/logger';
import BaseTag from 'components/atoms/base-tag';

import type { LoginStatus } from 'infrastructure/enums';

type IProps = {
  status: LoginStatus;
};

const DoctorStatusTag: React.FC<IProps> = ({ status }) => {
  const rec = loginStatusesDataSource().findByField('id', status);

  if (!rec) {
    debug(`DoctorStatusTag error: Invalid doctor status: ${status}`);
    return <></>;
  }

  return (
    <BaseTag
      size="large"
      color={rec.color as any}
      label={rec.name}
      dataCy="doctor-status-tag"
      transparent
      width="140px"
    />
  );
};

export default DoctorStatusTag;
